<template>
    <div>
       <label for="name">name:</label>
       <input type="text" id="name" placeholder="请输入name"  v-model="name"/>
       <br/>
       <label for="age">age:</label>
       <input type="text" id="age" placeholder="请输入年龄" v-model="age"/>
       <br/>
       <p>当前输入值:</p>
       <p>name:{{name}}</p>
       <p>age:{{age}}</p>
       <br/>
       <input @click="adduse()" type="button" value="添加数据" :disabled="name==''||age==''"/>
       <br/>
       <table style="border:1px solid #000;">
          <thead>
             <tr style="border:1px solid #000;">
                <td style="border:1px solid #000;">
                   <input type="checkbox" v-model="selectAll" @change="toggleSelectAll"/>全选/反选 
                </td>
                <td style="border:1px solid #000;">name</td>
                <td style="border:1px solid #000;">age</td>
                <td style="border:1px solid #000;">操作</td>
             </tr>
          </thead>
          <tr style="border:1px solid #000;" v-for="(item, index) in userlist" :key="item.name + index">
            <input type="checkbox" :checked="item.sel" v-model="item.sel" @change="updateSelectAll"/> 
            <td style="border:1px solid #000;">{{item.name}}</td>
            <td style="border:1px solid #000;">{{item.age}}</td>
            <td style="border:1px solid #000;">
                    <button @click="deleteItem(index)">删除</button>
                </td>
          </tr>
        </table>  
    </div>
</template>
<script>
import { Indicator, Toast } from 'mint-ui'
export default {
   name:'ttindex',
   data(){
     return{
        userlist:[{name:'tom',age:23,sel:true},{name:'jack',age:24,sel:false}],
        name:'',
        age:'',
        selectAll: false // 全选状态
     }
   },
   methods:{
      adduse(){
        if(this.name==""){
            Toast('请输入姓名');
            return false;
        }
        if(this.age==""){
            Toast('请输入年龄');
            return false;
        }
        // 检查是否已存在相同名字
        if(this.userlist.some(user => user.name === this.name.trim())) {
            Toast('该姓名已存在');
            return false;
        }
        this.userlist.push({name:this.name,age:this.age,sel:false});
        this.name="";
        this.age="";
        this.updateSelectAllState();
      },
      // 更新全选状态（当单个复选框改变时）
      updateSelectAll() {
          // 检查是否所有项都被选中
          this.selectAll = this.userlist.length > 0 && 
                           this.userlist.every(item => item.sel)
      },
      toggleSelectAll(){
        this.userlist.forEach(item => {
              item.sel = this.selectAll
          })
      },
      // 更新全选状态（用于外部调用）
      updateSelectAllState() {
          this.selectAll = this.userlist.length > 0 && 
                           this.userlist.every(item => item.sel)
      },
      // 删除单个项
      deleteItem(index) {
          if(confirm('确定要删除此项吗？')) {
              this.userlist.splice(index, 1)
              // 删除后更新全选状态
              this.updateSelectAllState()
          }
      },
   } 
}
</script>
